'use strict';

var location = window.location;

var toastMessageHelper = require('../utils/toastMessageHelper');
var amountFormatHelper = require('../utils/amountFormatHelper');
var $product = $('.product-tile');

var action = $('.page').data('action');
if (action === 'Product-Show') {
    $product = $('.product-detail');
}

var cartTitle = $product.data('carttitle');
var addMsg = $product.data('cartmsg');
var wishlistTitle = $product.data('wishlisttile');
var wishlistmsg = $product.data('removelabel');
var removedtile = $product.data('removedtile');

$(document).ready(function () {
    $('body').on('shown.bs.modal', '#sizeGuideModal', function () {
        var isAlreadyInCart = $('.sizeGuideExists').val() === 'true';
        if (isAlreadyInCart) {
            $('#sizeGuideModal').find('.add-to-cart').addClass('d-none');
            $('#sizeGuideModal').find('.go-to-cart-btn').removeClass('d-none');
        } else {
            $('#sizeGuideModal').find('.add-to-cart').removeClass('d-none');
            $('#sizeGuideModal').find('.go-to-cart-btn').addClass('d-none');
        }
    });

    if ($('.sticky-row').length) {
        $('#footercontent').addClass('extra-padd');
    }

    $('.card-header-accordion .accordion-modal-trigger').on('click', function () {
        $('.got-questions .mobile-modal-body .collapse.show').collapse('hide');
        $('.modile-model-container .scroll-bar, .stone-data.scroll-bar').scrollTop(0);
    });

    $('body').on('click', '.message-icon-checkbox, .mail-icon-checkbox, .whatsapp-icon-checkbox', function () {
        if ($(this).prop('checked')) {
            $('.invalid-feedback-sharevia').removeClass('d-block').addClass('d-none');
        }
    });

    $('#receiverName').on('input', function () {
        var $this = $(this);
        $this.removeClass('is-invalid');
        $('.invalid-feedback-recivername').addClass('d-none').removeClass('d-block');
    });

    $('#receiverEmail').on('input', function () {
        var $this = $(this);
        $this.removeClass('is-invalid');
        $('.emptyError, .regexError').addClass('d-none').removeClass('d-block');
    });

    $('#receiverMobileNumber').on('input', function () {
        var $this = $(this);
        $this.removeClass('is-invalid');
        $('.missing-feedback-recivercontact, .invalid-feedback-recivercontact').addClass('d-none').removeClass('d-block');
    });

    $('.giftvoucher-data-trigger').on('change', function () {
        if ($(this).val()) {
            $('.giftvoucher-date-picker').removeClass('is-invalid');
            $('.invalid-feedback-deliverydate').text('').removeClass('d-block');
        } else {
            var giftvoucherDataMissingError = $('.giftvoucher-data-trigger').data('missing-error');
            $('.giftvoucher-date-picker').addClass('is-invalid');
            $('.invalid-feedback-deliverydate').text(giftvoucherDataMissingError).addClass('d-block');
        }
    });

    var $alreadyInCartMsg = $('.js-already-in-cart-message');
    if ($alreadyInCartMsg.length > 0) {
        var msg = $alreadyInCartMsg.val();
        toastMessageHelper.showNotification(msg, '', 'Basket-icon');
    }

    $('body').on('wishlist:sync', function (e, data) {
        if (!data || !data.pid) {
            return;
        }

        var pidStr = String(data.pid);
        var isActive = !!data.isActive;

        $('.wishlist-btn, .pdpwishlist-btn').each(function () {
            var $btn = $(this);
            if (String($btn.data('pid')) !== pidStr) {
                return;
            }

            $btn.toggleClass('is-active', isActive);

            var $use = $btn.find('use');
            if (!$use.length) {
                return;
            }

            if ($btn.hasClass('pdpwishlist-btn')) {
                $use.attr('xlink:href', isActive ? '#redpdp-wishlisticon' : '#dpd-wishlisticon');
            } else {
                $use.attr('xlink:href', isActive ? '#wishlistfilledredicon' : '#wishlistnormalicon');
            }
        });
    });
});

/**
 * Returns the selected product quantity based on button action and product rules.
 * - Buy Now uses the selected quantity from the input.
 * - If the product is a coin product AND plus/minus buttons have specific classes → quantity = 1.
 * - If the input value is invalid, NaN, or less than 1 → quantity = 1.
 * - Otherwise → returns the parsed quantity from `.c-qty-input`.
 *
 * @function getQuantitySelector
 * @param {boolean} buyNowBtn - Indicates whether the Buy Now button was clicked.
 * @returns {number} The validated quantity value (minimum 1).
 */
function getQuantitySelector(buyNowBtn) {
    var maxclick = $('.ckc-qty-plus');
    var minClick = $('.ckc-qty-minus');
    var quantitySelected = parseInt($('.c-qty-input').val(), 10);

    // Prevent lint warning: use buyNowBtn to drive behavior while preserving default flow.
    if (buyNowBtn && (Number.isNaN(quantitySelected))) {
        quantitySelected = 1;
    }

    if ($('.coinProduct').val() === 'true' && (maxclick.hasClass('add-to-bag-increment') || minClick.hasClass('remove-from-bag-decrement'))) {
        quantitySelected = 1;
    } else if (Number.isNaN(quantitySelected) || quantitySelected < 1) {
        quantitySelected = 1;
    }
    return quantitySelected;
}

/**
 * Gets the selected quantity.
 * @param {boolean} buyNowBtn - If Buy Now was clicked.
 * @returns {number} Quantity value.
 */
function getQuantitySelected(buyNowBtn) {
    return getQuantitySelector(buyNowBtn);
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    $('.minicart-quantity').removeClass('d-none');
    // var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        // Commenting to avoid the SFCC Default Toast message
        // if ($('.add-to-cart-messages').length === 0) {
        //     $('body').append(
        //         '<div class="add-to-cart-messages"></div>'
        //     );
        // }

        // $('.add-to-cart-messages').append(
        //     '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
        //     + response.message
        //     + '</div>'
        // );

        // setTimeout(function () {
        //     $('.add-to-basket-alert').remove();
        // }, 5000);
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

/**
 * Initializes and manages the behavior of desktop accordions and modal dialogs
 * based on the current window width. On desktop (width >= 1024px), accordions
 * are shown using collapse behavior; on mobile, they are shown as modals.
 * Also handles toggling of header classes on accordion open/close and ensures
 * proper cleanup and state synchronization on window resize (debounced).
 *
 * Dependencies:
 * - jQuery
 * - Bootstrap's Collapse and Modal plugins
 *
 * Usage:
 * Call this function once after the DOM is ready to enable responsive
 * accordion/modal behavior for elements with the `.desktop-accordian` class.
 */
function setupDesktopAccordionModalBehavior() {
    /**
     * Synchronizes the state of the desktop accordions with the current window width.
     * In desktop view (width >= 1024px), accordions are shown using collapse behavior;
     * in mobile view, they are shown as modals.
     * This function is called once after the DOM is ready to enable responsive accordion/modal
     * behavior for elements with the `.desktop-accordian` class.
     *
     * @param {boolean} isDesktop - whether the current window width is in desktop view
     */
    function syncState(isDesktop) {
        $('.desktop-accordian').each(function () {
            var $accordion = $(this);
            var $trigger = $accordion.closest('.card-accordion').find('.accordion-modal-trigger');
            var $titleText = $accordion.closest('.card-accordion').find('.title-text');

            // Always reset nested accordion (applies in both views)
            $('#nested-accordion .title-text-question').addClass('collapsed');
            $('#nested-accordion .collapse.show').collapse('hide');

            if (isDesktop) {
                // Reset top-level accordion once
                $('#accordionExample .title-text').addClass('collapsed');
                $('#accordionExample .desktop-accordian.show').collapse('hide');

                // Ensure modal cleanup only if it's active
                if ($accordion.hasClass('modal')) {
                    $accordion.modal('hide').removeClass('modal');
                } else {
                    $accordion.removeClass('modal');
                }

                $trigger.attr('data-toggle', 'collapse');
                $accordion.removeAttr('style');

                // Remove old handlers before binding
                $accordion.off('.desktop');

                // Toggle header class only for this accordion
                $accordion
                    .on('show.bs.collapse.desktop', function (e) {
                        if (e.target === $accordion[0]) {
                            $titleText.addClass('active').removeClass('collapsed');
                        }
                    })
                    .on('hide.bs.collapse.desktop', function (e) {
                        if (e.target === $accordion[0]) {
                            $titleText.removeClass('active').addClass('collapsed');
                        }
                    });
            } else {
                // Mobile: switch to modal
                $accordion.addClass('modal');
                $trigger.attr('data-toggle', 'modal');
            }
        });
    }

    // Track current state
    var isDesktop = $(window).outerWidth() >= 1024;
    syncState(isDesktop);

    // Only run on actual breakpoint change
    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            var newIsDesktop = $(window).outerWidth() >= 1024;
            if (newIsDesktop !== isDesktop) {
                isDesktop = newIsDesktop;
                syncState(isDesktop);
            }
        }, 200);
    });
}

/**
 * Initializes the toggle button for stone data list.
 * If there is only one stone row, the toggle button is hidden.
 * If there are more than one stone row, the toggle button is shown and
 * its text is toggled between 'Show Less' and 'Show More' when clicked.
 */
function initStoneDataToggle() {
    var $stoneContainer = $('#stoneDataList');
    var $rows = $stoneContainer.find('.stone-row');
    var $toggle = $('#stoneToggle');

    // Apply only on devices up to 1024px
    if (window.innerWidth <= 1024) {
        // Only show toggle if more than 1 stone row
        if ($rows.length <= 1) {
            $toggle.hide();
        } else {
            $toggle.show();
            $toggle.off('click').on('click', function () {
                $stoneContainer.toggleClass('expanded');
                if ($stoneContainer.hasClass('expanded')) {
                    $toggle.text('Show Less');
                } else {
                    $toggle.text('Show More');
                }
            });
        }
    } else {
        // On desktop (above 1024px), always show all stones and hide toggle
        $stoneContainer.addClass('expanded');
        $toggle.hide();
    }
}

// Initialize on page load
initStoneDataToggle();

// This event handles scrolling the modal content to the top when it is shown
// We use 'shown.bs.modal' instead of click to ensure content is visible and scrollable
$('body').on('shown.bs.modal', '.desktop-accordian', function () {
    $(this).find('.modile-model-container .scroll-bar').scrollTop(0);
});

/**
 * Check if the voucher form is valid. If the form is not valid, return true.
 * If the form is valid, return false.
 *
 * @return {boolean} true if the form is not valid, false if the form is valid
 */
function voucherValidations() {
    const giftForm = $('.giftvoucher-form-forothers');
    if (!giftForm.hasClass('d-none')) {
        const formgiftFor = $('#giftvoucher-others');
        const formgiftReceiverName = $('#receiverName').val();
        const formgiftReceiverEmail = $('#receiverEmail').val();
        const formgiftReceiverMobileNumber = $('#receiverMobileNumber').val();
        const giftvoucherData = $('.giftvoucher-data-trigger').val();
        const checkedCount = $("input[name='giftvoucher-icon-checkbox']:checked").length;
        var isInvalid = false;
        if (formgiftFor.is(':checked')) {
            if (formgiftReceiverName === '') {
                $('.invalid-feedback-recivername').addClass('d-block');
                $('#receiverName').addClass('is-invalid');
                isInvalid = true;
            } else {
                $('.invalid-feedback-recivername').removeClass('d-block');
                $('#receiverName').removeClass('is-invalid');
            }
            if (formgiftReceiverEmail === '') {
                $('.invalid-feedback-reciveremail').addClass('d-block');
                $('.emptyError').removeClass('d-none');
                $('#receiverEmail').addClass('is-invalid');
                isInvalid = true;
            } else {
                const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
                if (!emailRegex.test(formgiftReceiverEmail)) {
                    $('.regexError').removeClass('d-none');
                    $('.invalid-feedback-reciveremail').addClass('d-block');
                    $('#receiverEmail').addClass('is-invalid');
                    isInvalid = true;
                } else {
                    $('.emptyError, .regexError').addClass('d-none');
                    $('.invalid-feedback-reciveremail').removeClass('d-block');
                    $('#receiverEmail').removeClass('is-invalid');
                }
            }
            if (formgiftReceiverMobileNumber === '') {
                $('.indian-phone-number').find('.invalid-feedback').addClass('d-block');
                $('.missing-feedback-recivercontact').removeClass('d-none');
                $('.invalid-feedback-recivercontact').addClass('d-none');
                $('#receiverMobileNumber').addClass('is-invalid');
                isInvalid = true;
            } else {
                const phoneRegex = /^[6-9][0-9]{9}$/;
                if (!phoneRegex.test(formgiftReceiverMobileNumber)) {
                    $('.invalid-feedback-recivercontact').removeClass('d-none');
                    $('.missing-feedback-recivercontact').addClass('d-none').removeClass('d-block');
                    $('#receiverMobileNumber').addClass('is-invalid');
                    isInvalid = true;
                } else {
                    $('.invalid-feedback-recivercontact, .missing-feedback-recivercontact').addClass('d-none').removeClass('d-block');
                    $('#receiverMobileNumber').removeClass('is-invalid');
                }
            }

            if (!$('.giftvoucher-date-picker').hasClass('d-none')) {
                if (giftvoucherData === '') {
                    var giftvoucherDataMissingError = $('.giftvoucher-data-trigger').data('missing-error');
                    $('.giftvoucher-date-picker').addClass('is-invalid');
                    $('.invalid-feedback-deliverydate').text(giftvoucherDataMissingError).addClass('d-block');
                    isInvalid = true;
                } else {
                    $('.giftvoucher-date-picker').removeClass('is-invalid');
                    $('.invalid-feedback-deliverydate').text('').removeClass('d-block');
                }
            }

            if (checkedCount === 0) {
                $('.invalid-feedback-sharevia').removeClass('d-none').addClass('d-block');
                isInvalid = true;
            } else {
                $('.invalid-feedback-sharevia').addClass('d-none').removeClass('d-block');
            }
        }
        if (isInvalid) {
            return true;
        }
        return false;
    }

    return voucherValidations;
}

module.exports = {

    colorAttribute: function () {
        $(document).on('click', '.swatch-attribute-btn, #more-swatch-modal .swatch-label-wrapper .modal-swatch-attribute', function (e) {
            e.preventDefault();

            if (!$(this).is('disabled') && !$(this).hasClass('view-more-button')) {
                var $productContainer = $(this).closest('.set-item');
                if (!$productContainer.length) {
                    $productContainer = $(this).closest('.product-detail');
                }

                if (!$('body > .veil').length) {
                    $.spinner().start();
                }
                window.location.href = $(this).data('url');
            }
        });
    },

    selectAttribute: function () {
        $(document).on('click', '.custom-drop-down-section .variation-option-select', function (e) {
            e.preventDefault();

            if (!$(this).attr('disabled')) {
                var $productContainer = $(this).closest('.set-item');
                if (!$productContainer.length) {
                    $productContainer = $(this).closest('.product-detail');
                }
                if (!$('body > .veil').length) {
                    $.spinner().start();
                }
                window.location.href = $(this).data('url');
            }
        });
    },

    addToCart: function () {
        $('body').on('blur', '#receiverName', function () {
            const formgiftReceiverName = $('#receiverName').val();
            if (formgiftReceiverName === '') {
                $('.invalid-feedback-recivername').addClass('d-block');
                $('#receiverName').addClass('is-invalid');
            } else {
                $('.invalid-feedback-recivername').removeClass('d-block');
                $('#receiverName').removeClass('is-invalid');
            }
        });
        $('body').on('blur', '#receiverMobileNumber', function () {
            const formgiftReceiverMobileNumber = $('#receiverMobileNumber').val();
            if (formgiftReceiverMobileNumber === '') {
                $('.indian-phone-number').find('.invalid-feedback').addClass('d-block');
                $('.missing-feedback-recivercontact').removeClass('d-none');
                $('.invalid-feedback-recivercontact').addClass('d-none');
                $('#receiverMobileNumber').addClass('is-invalid');
            } else {
                const phoneRegex = /^[6-9][0-9]{9}$/;
                if (!phoneRegex.test(formgiftReceiverMobileNumber)) {
                    $('.invalid-feedback-recivercontact').removeClass('d-none');
                    $('.missing-feedback-recivercontact').addClass('d-none').removeClass('d-block');
                    $('#receiverMobileNumber').addClass('is-invalid');
                } else {
                    $('.invalid-feedback-recivercontact, .missing-feedback-recivercontact').addClass('d-none').removeClass('d-block');
                    $('#receiverMobileNumber').removeClass('is-invalid');
                }
            }
        });
        $('body').on('blur', '#receiverEmail', function () {
            const formgiftReceiverEmail = $('#receiverEmail').val();

            if (formgiftReceiverEmail === '') {
                $('.emptyError').removeClass('d-none');
                $('.regexError').addClass('d-none');
                $('#receiverEmail').addClass('is-invalid');
            } else {
                const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
                if (!emailRegex.test(formgiftReceiverEmail)) {
                    $('.regexError').removeClass('d-none');
                    $('.emptyError').addClass('d-none');
                    $('#receiverEmail').addClass('is-invalid');
                } else {
                    $('.emptyError, .regexError').addClass('d-none');
                    $('#receiverEmail').removeClass('is-invalid');
                }
            }
        });

        $('.action-btns .add-to-bag , .action-btns .add-buy-now , .sticky-add-to-cart-btn, .buynow-button').on('click', function () {
            const giftCheck = $('.giftvoucher-accept');
            if (giftCheck && giftCheck.length) {
                if (!giftCheck.is(':checked')) {
                    $('.gift-voucher-error').removeClass('d-none');
                    return false;
                }
            }

            const giftForm = $('.giftvoucher-form-forothers');
            if (!giftForm.hasClass('d-none')) {
                var isValidForm = voucherValidations();
                if (isValidForm) {
                    // eslint-disable-next-line consistent-return
                    return false;
                }
            }
            // eslint-disable-next-line consistent-return
            return true;
        });

        // eslint-disable-next-line consistent-return
        $(document).on('click', 'button.addtocart, button.add-to-cart, button.add-to-cart-global', function (e) {
            e.stopPropagation();
            e.preventDefault();
            $('.ckc-max-limit-message').addClass('d-none');
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;
            var buyNowBtn = $(this).hasClass('buy-now');
            const guestUser = $(this).data('authcustomer') === false;
            if (buyNowBtn && guestUser && !$(this).hasClass('proceed-checkout')) {
                $('.login-modal-result, .login-modal-missing-error, .login-modal-customer-exists-error, .login-mobile-country-miss-match-error, .guest-login-modal-subtitle').addClass('d-none');
                $('.continue-as-guest-section').removeClass('d-none');
                $('#guestLoginInput').val('');
                $('.guest-continue-button').removeAttr('disabled');
                $('#guestLoginInput').addClass('w-100');
                $('.guest-country-select-wrap').addClass('d-none');
                if ($(this).data('guestloginmessage')) {
                    var $guestSubtitle = $('.guest-login-modal-subtitle');
                    var subtitleTemplate = $guestSubtitle.data('template');

                    if (!subtitleTemplate) {
                        subtitleTemplate = $guestSubtitle.text();
                        $guestSubtitle.data('template', subtitleTemplate);
                    }

                    var rawAmount = $(this).data('guestloginamount');
                    if (subtitleTemplate && rawAmount !== null && rawAmount !== undefined) {
                        var formattedAmount = amountFormatHelper.formatGuestThresholdAmount(rawAmount);
                        $guestSubtitle.text(subtitleTemplate.replace(/\{0\}/g, formattedAmount));
                    }

                    $guestSubtitle.removeClass('d-none');
                    $('.guest-continue-button').attr('disabled', true);
                    $('.continue-as-guest-section').addClass('d-none');
                }
                var $guestWrapDrop = $('.ckc-guest-login-countrycode-drop-down');
                $guestWrapDrop.find('.custom-option-value.active, .custom-option-value.selected').removeClass('active selected');
                var $guestDefaultOptions = $guestWrapDrop.find('.custom-option-value[data-id="+91"]');
                $guestDefaultOptions.addClass('active selected');
                $guestWrapDrop.find('.custom-drop-down-login .selected-value').text($guestDefaultOptions.data('id')).addClass('active');
                $('#ckc-guest-login-modal').modal('show');
                if ($(this).hasClass('buynow-button') || $(this).hasClass('buy-now')) {
                    sessionStorage.setItem('buyNowProductId', $(this).data('pid'));
                }
                return false;
            }
            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail').each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $(this).find('.product-id').text(),
                            qty: $(this).find('.quantity-select').val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = $(this).data('pid');

            var $productContainer = $(this).closest('.product-detail') || $(this).closest('.product-tile');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }

            var articleType = $('.product-article-type').val();
            var currencyCode = $('.session-currency-code').val();
            var localeSelected = $('.session-locale-selected').val();
            var giftVoucherType = $('.pref-gift-voucher-article-type').val();
            var paperGoldType = $('.pref-paper-gold-article-type').val();
            var paperSilverType = $('.pref-paper-silver-article-type').val();
            var giftVoucherErrorMsg = $('.msg-gift-voucher-error').val();
            var paperGoldErrorMsg = $('.msg-paper-gold-error').val();
            var paperSilverErrorMsg = $('.msg-paper-silver-error').val();
            $.spinner().stop();
            if (currencyCode === 'INR' && localeSelected !== 'IN') {
                if (articleType && articleType === giftVoucherType) {
                    toastMessageHelper.showNotification(giftVoucherErrorMsg);
                    return;
                }
                if (articleType && articleType === paperGoldType) {
                    toastMessageHelper.showNotification(paperGoldErrorMsg);
                    return;
                }
                if (articleType && articleType === paperSilverType) {
                    toastMessageHelper.showNotification(paperSilverErrorMsg);
                    return;
                }
            }

            addToCartUrl = getAddToCartUrl() || $(this).data('url');
            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                addToCart: $(this).hasClass('proceed-checkout') ? false : true, // eslint-disable-line
                quantity: getQuantitySelected(buyNowBtn)
            };

            if ($('.isGiftCardPage').length > 0 && $('.isGiftCardPage').val() === 'true') {
                form.isGiftCardPage = $('.isGiftCardPage').val();
                form.giftFor = $('#giftvoucher-others').prop('checked');

                // Check if "For Myself" is selected
                var isForMyself = $('#giftvoucher-myself').prop('checked');

                if (isForMyself) {
                    // When "For Myself" is selected, set all delivery channels to true
                    form.giftShareviaWhatsapp = true;
                    form.giftShareviaMessage = true;
                    form.giftShareviaEmail = true;
                    // Set receiver details to null for "For Myself"
                    form.giftReceiverName = $('#receiver-name').val();
                    form.giftReceiverEmail = $('#receiver-email').val();
                    form.giftReceiverMobileNumber = $('#receiver-phone').val();
                    form.giftMessageForReceiver = 'null';
                    form.giftReceiverTime = 'sendnow';
                    var today = new Date();
                    var dd = String(today.getDate()).padStart(2, '0');
                    var mm = String(today.getMonth() + 1).padStart(2, '0');
                    var yyyy = today.getFullYear();
                    form.giftReceiverDate = dd + '-' + mm + '-' + yyyy;
                } else {
                    // When "For Others" is selected, use the selected values
                    form.giftReceiverName = $('#receiverName').val() || 'null';
                    form.giftReceiverEmail = $('#receiverEmail').val() || 'null';
                    form.giftReceiverMobileNumber = $('#receiverMobileCountryCode').val() + $('#receiverMobileNumber').val() || 'null';
                    form.giftMessageForReceiver = $('#giftMessageForReceiver').val() || 'null';
                    form.giftReceiverTime = $('input[name="giftvoucher-delivery-date"]:checked').val();

                    var dateValue = $('.giftvoucher-data-trigger').val();
                    if (dateValue) {
                        var dateParts = dateValue.split('/');
                        var day = dateParts[0];
                        var month = dateParts[1];
                        var year = dateParts[2];
                        form.giftReceiverDate = year + '-' + month + '-' + day;
                    } else {
                        form.giftReceiverDate = '';
                    }

                    form.giftShareviaWhatsapp = $('.whatsapp-icon-checkbox').is(':checked');
                    form.giftShareviaMessage = $('.message-icon-checkbox').is(':checked');
                    form.giftShareviaEmail = $('.mail-icon-checkbox').is(':checked');
                }
            }

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            var $this = $(this);
            var sizeGuideExists = $('.sizeGuideExists').val();
            var addToCartOption = $this.hasClass('add-to-cart-option');
            // Inject isRegistry flag when present in the page URL (e.g., GiftRegistry-Show?isRegistry=true)
            var params = new URLSearchParams(window.location.search);
            if (params.get('isRegistry') === 'true') {
                form.isRegistry = 'true';
            }
            $(this).trigger('updateAddToCartFormData', form);
            var isBuynow = $(this).hasClass('buy-now') || $($this).hasClass('add-buy-now');
            if (addToCartUrl) {
                if ($this.data('ckc-click-lock')) {
                    return false;
                }
                $this.data('ckc-click-lock', true);
                $this.prop('disabled', true);
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        /* eslint consistent-return: "off" */
                        if (data.error && data.message) {
                            toastMessageHelper.showNotification(data.message);
                            $.spinner().stop();
                            return;
                        }
                        if (sizeGuideExists === 'false') {
                            $('#sizeGuideModal').find('.go-to-cart-btn').addClass('d-none');
                            $('#sizeGuideModal').find('.add-to-cart').removeClass('d-none');
                        }
                        if ($('#sizeGuideModal').hasClass('show')) {
                            $('.sizeGuideExists').val('true');
                            $('.modal-close').trigger('click');
                        }
                        if ($(this).hasClass('add-to-cart-option')) {
                            $(this).addClass('d-none');
                            $(this).closest('.cart-and-ipay').find('.go-to-cart-btn').removeClass('d-none');
                        }
                        var inputVal = parseInt($('.c-qty-input').val(), 10);
                        var productAts = parseInt($('.productATSValue').val(), 10);
                        if (inputVal === productAts && !$this.hasClass('add-to-cart-global') && !sizeGuideExists === 'true') {
                            if ($this.closest('.bulk-order-details').length === 0) {
                                $('.ckc-qty-plus').addClass('max-disabled disablestate');
                                $('.ckc-qty-plus').prop('disabled', true);
                            }
                            const warnMsg = $('#warning-msg').val();
                            $('.ckc-max-limit-message').removeClass('d-none').text(warnMsg);
                        }
                        if (!isBuynow) {
                            handlePostCartAdd(data);
                            toastMessageHelper.showNotification(cartTitle, addMsg, 'Basket-icon');
                        }
                        $('body').trigger('product:afterAddToCart', data);
                        if (($this.closest('.product-detail').length)) {
                            if ($this.closest('.bulk-order-details').length === 0) {
                                $('.product-gallery-pdp').find('.c-qty-input').prop('disabled', true);
                            }
                            if ($('.coinProduct').val() === 'true') {
                                $('.product-gallery-pdp').find('.max-click').addClass('add-to-bag-increment');
                                $('.product-gallery-pdp').find('.mini-click').addClass('remove-from-bag-decrement');
                            }
                        }
                        if ((!$this.closest('.product-detail').length)) {
                            if (!isBuynow) {
                                $this.addClass('d-none');
                                $this.closest('.additional-details').find('.go-to-cart-btn').removeClass('d-none');
                            }
                        } else if (!isBuynow) {
                            $this.addClass('d-none');
                            $this.siblings('.go-to-cart-btn').removeClass('d-none').addClass('hide-cart-btn');
                            if (!addToCartOption) {
                                $('.seebag').removeClass('d-none');
                                $('.add-to-bag, .addtocart').addClass('d-none');
                            }
                        }
                        if ($this.hasClass('add-to-bag')) {
                            $('.ckc-max-limit-message').addClass('d-none').text('');
                        }
                        var maxquantity = parseInt($('.productMaxOrderQty').val(), 10);
                        var warnMsg = $('#warning-msg').val();
                        if (inputVal === maxquantity && $('.coinProduct').val() === 'true' && $this.hasClass('from-incre')) {
                            $('.ckc-max-limit-message').removeClass('d-none').text(warnMsg);
                        } else {
                            $this.removeClass('from-incre');
                        }
                        // 🔹 Update UUID in quantity selector elements
                        var $qtySection = $this.closest('.ckc-quantity-selector');
                        if (!$qtySection.length) {
                            $qtySection = $this.closest('.product-detail').find('.ckc-quantity-selector');
                        }
                        $qtySection.find('.ckc-qty-minus, .c-qty-input, .ckc-qty-plus').attr('data-uuid', data.pliUUID);
                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                        // Redirect for buy-now journey
                        if (isBuynow && data.isBuyNowJourney && data.redirectUrl) {
                            window.location.href = data.redirectUrl;
                            return;
                        }
                        if (data && data.redirect) {
                            window.location.href = data.redirectUrl;
                        }
                        if (!data.redirect && action === 'Cart-Show') {
                            location.reload();
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    },
                    complete: function () {
                        $this.data('ckc-click-lock', false);
                        $this.prop('disabled', false);
                    }
                });
            }
        });
    },
    changeAttribute: function () {
        $('body').on('click', '.custom-option-value', function () {
            var $option = $(this);
            var newValue = $option.data('id');
            var $section = $option.closest('.custom-drop-down-section');
            var $select = $section.find('select');
            $section.find('.custom-option-values').hide();
            $select.val(newValue).trigger('change');
        });
    },
    tryOn: function () {
        $('body').on('click', '#tryOnButton', function (e) {
            var ckcBrandKey = $('#ckcBrandKey').val();
            var ckcMirrArCDNLink = $('#ckcMirrArCDNLink').val();
            e.preventDefault();
            var productId = $(this).closest('.product').data('pid'); // send pid with 'AR-' prefix
            var script = document.createElement('script');
            var options = {
                brandId: ckcBrandKey,
                variantSku: productId
            };

            script.src = ckcMirrArCDNLink;
            script.onload = function () {
                if (typeof window.initMirrarUI === 'function') {
                    window.initMirrarUI(productId, options);
                }
            };
            document.body.append(script);
        });
    },

    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl,
    setupDesktopAccordionModalBehavior: setupDesktopAccordionModalBehavior
};

/**
 * Handles the submission of the wishlist form when the `.wishlistform-btn` element is triggered.
 *
 * This function prevents the default form submission behavior and toggles a product's wishlist status
 * using an AJAX request (GET for removal, POST for addition). It updates the UI by:
 * - Toggling the `is-active` class on the button
 * - Switching the `<use>` icon reference
 * - Updating the `title` attribute
 * - Displaying a toast message via `toastMessageHelper`
 *
 * Assumes:
 * - The button inside the form has class `.wishlist-btn`
 * - It uses `data-add-url` and `data-remove-url` for endpoints
 * - The button also has `data-pid` for product ID
 * - SVG icon `<use>` is present within the button
 *
 * Global variables assumed:
 * - `wishlistTitle`, `removedtile`, `addMsg`, `wishlistmsg`
 * - `createaddWishlisticonSVG()`, `createremoveWishlisticonSVG()`
 *
 * @event submit
 * @selector .wishlistform-btn
 * @param {Event} e The form submission event
 *
 */
$(document).on('submit', '.wishlistform-btn', function (e) {
    e.preventDefault();

    var $form = $(this);
    var $button = $form.find('.wishlist-btn');
    var $iconUse = $button.find('use');
    var productId = $button.data('pid');

    if ($('.isAuthenticated').val() !== 'true') {
        $('.country-select-wrap').addClass('d-none');
        $('#loginInput').addClass('w-100');
        $('.login-modal-missing-error, .login-modal-customer-exists-error, .login-modal-result, .login-mobile-country-miss-match-error, #register-form-modal, .ckc-password-register-content, .ckc-register-form-content').addClass('d-none');
        window.localStorage.setItem('wishlistPid', productId);
        $('#ckc-login-modal').modal('show');
        return;
    }
    var isInWishlist = $button.hasClass('is-active');
    var url = isInWishlist ? $button.data('remove-url') : $button.data('add-url');
    var method = isInWishlist ? 'GET' : 'POST';

    $.ajax({
        url: url,
        method: method,
        data: {
            pid: productId
        },
        dataType: 'json',
        success: function (data) {
            if (data.success) {
                $button.toggleClass('is-active');
                var isNowInWishlist = $button.hasClass('is-active');

                $('body').trigger('wishlist:sync', {
                    pid: productId,
                    isActive: isNowInWishlist
                });

                $iconUse.attr('xlink:href', isNowInWishlist ? '#wishlistfilledredicon' : '#wishlistnormalicon');

                $button.attr('title', isNowInWishlist ? wishlistTitle : removedtile);

                if (isNowInWishlist) {
                    toastMessageHelper.showNotification(wishlistTitle, addMsg, 'wishlistfilledredicon');
                    $('.toast-icon').removeClass('removed-wishlist');
                } else {
                    toastMessageHelper.showNotification(removedtile, wishlistmsg, 'wishlistnormalicon');
                    $('.toast-icon').addClass('removed-wishlist');
                }
                if ($('.page').data('action') === 'Cart-Show') {
                    $.spinner().start();
                    window.location.reload();
                }
            }
        },
        error: function () {
            toastMessageHelper.showNotification(
                'UNFORTUNATELY !',
                'Something went wrong. Please try again.'
            );
        }
    });
});

$(document).on('click', '.url-copy-btn', function (e) {
    e.preventDefault();
    var $copyurl = $('.url-copy-btn');
    var copiedMsg = $copyurl.data('copymessage');
    toastMessageHelper.showNotification(copiedMsg, null, null, { urlButton: true });
});

// Redirect to Customize Page on button click
$('body').on('click', '.customize-product-btn, .custom-order-button', function () {
    var $btn = $(this);
    var url = $btn.data('url');

    // Check currency for customize-product-btn
    if ($btn.hasClass('customize-product-btn')) {
        var currentCurrency = $('.currency-options').data('currency');

        if (currentCurrency && currentCurrency !== 'INR') {
            // Show currency change modal
            $('#currencychangecustomizationrestrictionmodal').modal('show');
            return false;
        }
    }

    window.location.href = url;
});

$(document).on('click', '.ps-modal-close', function () {
    // Remove expanded class from the stone data section
    $('#stoneDataList').removeClass('expanded');
    // Show the Show More link and reset its text
    $('#stoneToggle').removeClass('d-none').text('Show More');
});
